<template>
    <client-page>
        <sub-visual subTab sh="About us" index="04" total="04" tabActive="Location" bg="/images/sub/visual/sv1.jpg" />

        <section class="section section--first pb-0">
            <v-container>
                <div class="tit-wrap">
                    <h2 class="tit tit--lg dot-tit">Location</h2>
                </div>

                <v-tabs grow show-arrows center-active class="v-tab--primary">
                    <v-tab to="/aboutus/location/paju"><span>Paju Main Office</span></v-tab>
                    <v-tab to="/aboutus/location/ulsan"><span>Ulsan Branch</span></v-tab>
                    <v-tab to="/aboutus/location/daesan"><span>Daesan Branch</span></v-tab>
                </v-tabs>
            </v-container>
        </section>

        <section class="section section--last pt-0">
            <v-container>
                <div class="h-400px h-lg-600px">
                    <div id="map2" style="width:100%; height:100%;"></div>
                </div>
                <!-- <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3248.640047993585!2d129.30058085102795!3d35.48844874803066!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35662cc321fee257%3A0x2cb5c5ba0343c7e1!2z7Jq47IKw6rSR7Jet7IucIOyauOyjvOq1sCDssq3rn4nrqbQg7IOB64Ko66asIDgxNA!5e0!3m2!1sko!2skr!4v1675851685027!5m2!1sko!2skr" width="100%" height="600" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> -->

                <div class="pt-60 pt-md-80 pt-lg-100">
                    <h3 class="tit top-line-tit mb-16 mb-md-50 mb-lg-80">Contact us</h3>

                    <v-divider />
                    <div class="py-20 py-md-40">
                        <v-row align="center" justify-xl="space-between">
                            <v-col cols="12" lg="auto">
                                <v-row align="center">
                                    <v-col cols="auto">
                                        <v-img src="/images/icon/icon-tel.png" />
                                    </v-col>
                                    <v-col cols="">
                                        <span>+82 52-260-3121, 010-2569-3472</span>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" lg="auto">
                                <v-row align="center">
                                    <v-col cols="auto">
                                        <v-img src="/images/icon/icon-mail.png" />
                                    </v-col>
                                    <v-col cols="">
                                        <span>jin@kiesys.co.kr</span>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" lg="auto">
                                <v-row align="center">
                                    <v-col cols="auto">
                                        <v-img src="/images/icon/icon-address.png" />
                                    </v-col>
                                    <v-col cols="">
                                        <span>19-1, Santtgnam 2-gil, Cheontgnyang-eup, Ulju-gun, Ulsan, Republic <br class="d-none d-lg-block" />of Korea</span>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </div>
                    <v-divider />
                </div>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/en/sub/sub-visual.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
    },
    data() {
        return {
            map: null,
            mapCenter: { lat: 35.4886, lng: 129.3028 },
        };
    },
    mounted() {
        this.init();
        this.initMap();
        this.setMarker(this.mapCenter, "/images/icon/icon-pin.png");
    },
    methods: {
        init() {},
        initMap() {
            this.map = new google.maps.Map(document.getElementById("map2"), {
                //getElementById로 map id 속성의 요소를 가져온다.
                center: this.mapCenter, //center로 할 위도, 경도를 지정한다.
                zoom: 17, //zoom size를 지정.
                maxZoom: 20,
                minZoom: 3,
                streetViewControl: true,
                mapTypeControl: true,
                fuulscreenControl: true,
                zoomControl: true,
            });
        },
        setMarker(Points, Icon) {
            //지도에 마커를 찍는 함수.
            const markers = new google.maps.Marker({
                position: Points,
                map: this.map,
                icon: Icon, //마커 이미지
                title: "케이아이이시스템즈(주)", // 마커에 마우스를 올렸을때 간략하게 표기될 설명글
            });
        },
    },
};
</script>

<style scoped></style>
